import moment from "moment";

export const getters = {
  tokenExpires: state => {
    return !state.user.isSignedIn ? null : moment.utc(state.user.details.tokenExpiresUtc);
  },
  claims: state => (state.user.isSignedIn ? state.user.details.claims : []),  
  isSignedIn: state => state.user.isSignedIn,
  mustChangePassword: state => state.user.isSignedIn && state.user.details.mustChangePassword,
  mfaEnforced: (state, getters) => {
    return getters.mfaMode == "EnforcedOptOut" || getters.mfaMode == "EnforcedSiteWide";
  }
};
